<template>
  <main>
    <div
      style="position: fixed; top: 20px; z-index: 3; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div
        class="
          asc-page-heading-2
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <img
            @click="goBack()"
            class="mr-3 pointer"
            src="@/assets/customfield/blueBackArrow.svg"
            alt
          />
          View Onboarding Documents
        </div>
      </div>

      <main class="ondoc-white-cont">
        <section
          class="ondoc-body d-flex justify-content-between w-100"
          :style="
            (getUploadedDocCount == 0 ||
              !roles.includes('REVIEW_ONBOARDING_DOCS')) &&
            'height: calc(100vh - 155px) !important;'
          "
        >
          <section class="ondoc-left">
            <h4 class="mt-2">
              {{
                getFilteredDocs[1].length == documentData.fields.length
                  ? "All documents have been accepted"
                  : getUploadedDocCount == 0
                  ? `Candidate has to upload ${formattedNumberDoc(
                      getFilteredDocs[0].length
                    )}`
                  : `Candidate has uploaded ${formattedNumberDoc(
                      getUploadedDocCount
                    )}`
              }}
            </h4>
            <div class="ondoc-left-inner invisible-scroll">
              <article v-for="doc in getFilteredDocs[0]" :key="doc.key">
                <div
                  v-if="multipleDocs(doc)"
                  :class="{
                    pointer: doc.documentStatus != 3,
                    'open-toggle-card': activeCardKey == doc.key && doc.show,
                  }"
                  class="doc-open-card mt-3"
                >
                  <article
                    ref="docCard"
                    :class="{
                      'doc-blue': selectedDoc && selectedDoc.key == doc.key,
                    }"
                    @click="
                      doc.documentStatus != 3 ? toggleCollapse(doc.key) : ''
                    "
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      doc-card
                    "
                  >
                    <div class="d-flex align-items-center ondoc-black-txt">
                      <img
                        class="mr-2 pointer"
                        src="@/assets/OnboardingDoc/doc.svg"
                        alt
                      />
                      <span>{{ doc.label }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <article
                        class="ondoc-tag"
                        :style="
                          getUploadedDocCount.length != 0 &&
                          doc.documentStatus == 3 &&
                          'margin-right: 27px'
                        "
                        :class="getDocStatus(doc, doc.documentStatus)[1]"
                      >
                        {{ getDocStatus(doc, doc.documentStatus)[0] }}
                      </article>
                      <img
                        v-if="doc.documentStatus != 3"
                        class="pointer ml-2"
                        src="@/assets/OnboardingDoc/right-arrow.svg"
                        alt
                      />
                    </div>
                  </article>
                  <b-collapse
                    style="padding-bottom: 3px"
                    :visible="activeCardKey == doc.key && doc.show"
                  >
                    <div class="list-text px-2 mb-2">
                      <h5
                        @click="selectMultiDoc(doc, index)"
                        :class="{
                          'doc-selected':
                            selectedDoc &&
                            selectedDoc.selectedIndex ==
                              `${index}-${doc.multiFields[index].label}`,
                        }"
                        v-for="(multidoc, index) in doc.multiFields"
                        :key="index"
                        class="mt-2 text-truncate"
                      >
                        <span class="font-lato mr-2" style="font-weight: 500"
                          >{{ index + 1 }}.</span
                        >
                        <span v-b-tooltip.hover.bottom="multidoc.label">{{
                          multidoc.label
                        }}</span>
                      </h5>
                    </div>
                  </b-collapse>
                </div>

                <article
                  v-else
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    mt-3
                    doc-card
                  "
                  :class="{
                    'doc-blue': selectedDoc && selectedDoc.key == doc.key,
                    pointer: doc.documentStatus != 3,
                  }"
                  @click="
                    doc.documentStatus != 3
                      ? ((activeCardKey = doc.key), (selectedDoc = doc))
                      : ''
                  "
                >
                  <div class="d-flex align-items-center ondoc-black-txt">
                    <img
                      class="mr-2 pointer"
                      src="@/assets/OnboardingDoc/doc.svg"
                      alt
                    />
                    {{ doc.label }}
                    <span v-if="doc.mandatory" class="asterik">*</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <article
                      class="ondoc-tag"
                      :style="
                        doc.documentStatus == 3 &&
                        !noDocUploadedOrRej &&
                        'margin-right: 27px'
                      "
                      :class="getDocStatus(doc, doc.documentStatus)[1]"
                    >
                      {{ getDocStatus(doc, doc.documentStatus)[0] }}
                    </article>
                    <img
                      v-if="doc.documentStatus != 3"
                      class="pointer ml-2"
                      src="@/assets/OnboardingDoc/right-arrow.svg"
                      alt
                    />
                  </div>
                </article>
              </article>
              <template v-if="getFilteredDocs[1].length != 0">
                <hr
                  v-if="getFilteredDocs[1].length != documentData.fields.length"
                />
                <h4
                  v-if="getFilteredDocs[1].length != documentData.fields.length"
                  class="mt-2"
                >
                  Previously Accepted Documents
                </h4>
                <article
                  ref="collapseWrappers"
                  v-for="doc in getFilteredDocs[1]"
                  :key="doc.key"
                >
                  <div
                    v-if="multipleDocs(doc)"
                    class="doc-open-card mt-3 pointer"
                    :class="{
                      'open-toggle-card': activeCardKey == doc.key && doc.show,
                    }"
                  >
                    <article
                      ref="docCard"
                      :class="{
                        'doc-blue': selectedDoc && selectedDoc.key == doc.key,
                      }"
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        doc-card
                      "
                      @click="toggleCollapse(doc.key)"
                    >
                      <!-- v-b-toggle.collapse-1 -->
                      <div class="d-flex align-items-center ondoc-black-txt">
                        <img
                          class="mr-2 pointer"
                          src="@/assets/OnboardingDoc/doc.svg"
                          alt
                        />
                        <span>{{ doc.label }}</span>
                      </div>
                      <div class="d-flex align-items-center">
                        <article
                          class="ondoc-tag"
                          :class="getDocStatus(doc, doc.documentStatus)[1]"
                        >
                          {{ getDocStatus(doc, doc.documentStatus)[0] }}
                        </article>
                        <img
                          class="pointer ml-2"
                          src="@/assets/OnboardingDoc/right-arrow.svg"
                          alt
                        />
                      </div>
                    </article>
                    <b-collapse
                      style="padding-bottom: 3px"
                      :visible="activeCardKey == doc.key && doc.show"
                    >
                      <div class="list-text px-2 mb-2">
                        <h5
                          @click="selectMultiDoc(doc, index)"
                          :class="{
                            'doc-selected':
                              selectedDoc &&
                              selectedDoc.selectedIndex ==
                                `${index}-${doc.multiFields[index].label}`,
                          }"
                          v-for="(multidoc, index) in doc.multiFields"
                          :key="index"
                          class="mt-2 text-truncate"
                        >
                          <span class="font-lato mr-2" style="font-weight: 500"
                            >{{ index + 1 }}.</span
                          >
                          <span v-b-tooltip.hover.bottom="multidoc.label">{{
                            multidoc.label
                          }}</span>
                        </h5>
                      </div>
                    </b-collapse>
                  </div>

                  <article
                    v-else
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mt-3
                      doc-card
                      pointer
                    "
                    :class="{
                      'doc-blue': selectedDoc && selectedDoc.key == doc.key,
                    }"
                    @click="(activeCardKey = doc.key), (selectedDoc = doc)"
                  >
                    <div class="d-flex align-items-center ondoc-black-txt">
                      <img
                        class="mr-2 pointer"
                        src="@/assets/OnboardingDoc/doc.svg"
                        alt
                      />
                      {{ doc.label }}
                      <span v-if="doc.mandatory" class="asterik">*</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <article
                        class="ondoc-tag"
                        :class="getDocStatus(doc, doc.documentStatus)[1]"
                      >
                        {{ getDocStatus(doc, doc.documentStatus)[0] }}
                      </article>
                      <img
                        class="pointer ml-2"
                        src="@/assets/OnboardingDoc/right-arrow.svg"
                        alt
                      />
                    </div>
                  </article>
                </article>
              </template>
            </div>
          </section>

          <div class="ondoc-right">
            <header
              v-if="!noDocUploadedOrRej && selectedDoc"
              class="ondoc-header d-flex justify-content-between w-100"
            >
              <span
                class="text-truncate"
                :class="
                  (selectedDoc.documentStatus == 2 ||
                    selectedDoc.documentStatus == 4) &&
                  'w-80'
                "
                >{{ selectedDoc.label }}</span
              >
              <div
                v-if="!checkProtected(selectedDoc)"
                :class="
                  selectedDoc.documentStatus != 0 &&
                  selectedDoc.documentStatus != 1 &&
                  'mr-3'
                "
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  pointer
                  gap-5px
                "
                @click="downloadLink(getSelectedLink())"
              >
                <img
                  class="pointer"
                  height="15"
                  src="@/assets/newJD/newCand-download-icon.svg"
                  alt
                />
                <div class="download-blue-text">Download</div>
              </div>
              <div
                v-if="
                  selectedDoc.documentStatus != 0 &&
                  selectedDoc.documentStatus != 1 &&
                  roles.includes('REVIEW_ONBOARDING_DOCS')
                "
                class="d-flex align-items-center"
              >
                <article
                  class="ondoc-tag redline pointer"
                  @click="changeDocStatus(false)"
                >
                  Reject
                </article>
                <article
                  class="ondoc-tag bluebtn ml-3 pointer"
                  @click="changeDocStatus(true)"
                >
                  Accept
                </article>
              </div>
            </header>
            <div
              v-if="selectedDoc"
              class="ondoc-overflow invisible-scroll"
              id="scrollToTop"
              :style="
                (!noDocUploadedOrRej && getUploadedDocCount == 0) ||
                !roles.includes('REVIEW_ONBOARDING_DOCS')
                  ? 'height: calc(100vh - 290px) !important;'
                  : getUploadedDocCount == 0 &&
                    getFileType(getSelectedLink())[0] == 'pdf' &&
                    !checkProtected(selectedDoc)
                  ? 'height: calc(100vh - 250px) !important;'
                  : ''
              "
              :class="{
                'h-100':
                  getFileType(getSelectedLink())[0] != 'pdf' ||
                  checkProtected(selectedDoc),
              }"
            >
              <div
                v-if="
                  checkProtected(selectedDoc) ||
                  getFileType(getSelectedLink())[0] != 'pdf'
                "
                class="h-100 d-flex align-items-center justify-content-center"
              >
                <div class="ondoc-word-resume">
                  <div class="text-center">
                    <img
                      v-if="checkProtected(selectedDoc)"
                      src="@/assets/img/foldericons/protected-icon.svg"
                      alt
                    />
                    <img v-else :src="getFileType(getSelectedLink())[1]" alt />
                  </div>
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mt-2
                    "
                  >
                    <div
                      class="
                        newCand-word-resume-font
                        text-truncate text-right
                        w-100
                        text-center
                      "
                    >
                      {{ getFileNameFromLink(getSelectedLink()) }}
                    </div>
                  </div>
                  <div class="slating-sub-text">
                    {{
                      checkProtected(selectedDoc)
                        ? "Protected Document"
                        : "Download the document to view it"
                    }}
                  </div>
                </div>
              </div>
              <div v-else class="ondoc-document">
                <pdf
                  class="h-100 w-100 viewReseme-canvas"
                  ref="pdf"
                  :src="getSelectedLink()"
                  :page="currentPage"
                  @num-pages="numPages = $event"
                  @link-clicked="currentPage = $event"
                  @page-loaded="currentPage = $event"
                ></pdf>
              </div>
            </div>
            <div
              v-else-if="noDocUploadedOrRej"
              class="
                ondoc-overflow
                d-flex
                flex-column
                h-100
                align-items-center
                justify-content-center
              "
            >
              <img src="@/assets/OnboardingDoc/noDoc-uploaded.svg" alt />
              <span class="nodoc-txt mt-4">No Document Uploaded</span>
            </div>

            <div
              v-if="
                selectedDoc &&
                !checkProtected(selectedDoc) &&
                getFileType(getSelectedLink())[0] == 'pdf'
              "
              class="
                viewResume-paginaTion-modal
                align-items-center
                justify-content-center
                d-flex
                w-100
              "
            >
              <div class="pagination">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="numPages"
                  :per-page="perPage"
                  align="center"
                  first-number
                  last-number
                >
                  <template #prev-text>
                    <span>
                      <img src="@/assets/img/accessconnew/pageleft.svg" alt />
                    </span>
                  </template>
                  <template #next-text>
                    <span>
                      <img src="@/assets/img/accessconnew/pageright.svg" alt />
                    </span>
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
        </section>
        <footer
          v-if="
            getUploadedDocCount != 0 && roles.includes('REVIEW_ONBOARDING_DOCS')
          "
          class="
            ondoc-footer
            d-flex
            align-items-center
            justify-content-end
            bluebtn
            pr-3
          "
        >
          <b-button @click="goBack()" class="acs-cancelBtn-modal mr-3"
            >Cancel</b-button
          >
          <div class="position-relative">
            <b-button
              :disabled="!showConfirmButton()"
              @click="showConfirmButton() ? (showConfirm = true) : ''"
              class="acs-addBtn-modal pl-4 pr-4"
              >Confirm</b-button
            >
          </div>
        </footer>
      </main>
    </div>
    <ConfirmDocsModal
      v-if="showConfirm"
      :showConfirm="showConfirm"
      :documentData="documentData"
      :acceptedDocsByType="acceptedDocsByType"
      @close-modal="showConfirm = false"
      @success="goBack()"
    />
  </main>
</template>

<script>
import pdf from "vue-pdf";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import ConfirmDocsModal from "./modals/ConfirmDocsModal.vue";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
import { getKanbanDocs } from "@/utils/apiFunctions";
import { getFileType, getFileNameFromLink } from "@/controllers/commonHelpers";
import { mapGetters } from "vuex";

export default {
  name: "Documents",
  data() {
    return {
      LoaderStatus: false,
      showConfirm: false,
      selectedDoc: null,
      activeCardKey: null,
      currentPage: 1,
      perPage: 1,
      numPages: 0,
      documentData: { fields: [] },
    };
  },
  components: { Spinner, pdf, ConfirmDocsModal },
  created() {
    this.getKanbanDocs();
  },
  watch: {
    selectedDoc(val) {
      if (val && this.getFileType(this.getSelectedLink())[0] == "pdf") {
        this.scrollTop();
      }
    },
  },
  computed: {
    ...mapGetters({ roles: "roles" }),
    getFilteredDocs() {
      let oldDocs = this.documentData.fields.filter(
        (obj) => obj.documentStatus == 1
      );
      let newDocs = this.documentData.fields.filter(
        (obj) => obj.documentStatus != 1
      );
      return [newDocs, oldDocs];
    },
    getUploadedDocCount() {
      let uploadedDocs = this.documentData.fields.filter(
        (obj) => obj.documentStatus == 2 || obj.documentStatus == 4
      );
      return uploadedDocs.length;
    },
    noDocUploadedOrRej() {
      let values = this.documentData.fields.filter(
        (obj) => obj.documentStatus == 3
      ).length;
      return values == this.documentData.fields.length;
    },
  },
  methods: {
    multipleDocs(doc) {
      return doc?.allowMultiple && doc?.uploadedFileLinks?.length > 1;
    },
    scrollTop() {
      if (document.getElementById("scrollToTop") != null) {
        let element = document.getElementById("scrollToTop");
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    formattedNumberDoc(num) {
      let numVal = num < 10 ? `0${num}` : num;
      return num > 1 ? `${numVal} documents` : `${numVal} document`;
    },
    toggleCollapse(key) {
      this.documentData.fields.map((obj) => {
        if (obj.key == key)
          obj.show = this.activeCardKey != key ? true : !obj.show;
        if (obj.show) {
          this.selectMultiDoc(obj, 0);
        }
        return obj;
      });
      this.activeCardKey = key;
      this.$forceUpdate();
    },
    getFileNameFromLink(fileName) {
      return getFileNameFromLink(fileName);
    },
    async checkIfPasswordProtected(url) {
      try {
        await pdfjsLib.getDocument(url).promise;
        // PDF is accessible, not password-protected
      } catch (error) {
        //  || error.name === "InvalidPDFException"
        if (error?.name === "PasswordException") {
          console.warn("Password protected PDF detected");
          return true;
        }
      }
      return false;
    },
    showConfirmButton() {
      let submittedLength = this.documentData.fields.filter(
        (obj) =>
          (obj.documentStatus == 2 || obj.documentStatus == 4) &&
          obj.documentStatus != obj.localDocStatus
      ).length;
      let totalLength = this.documentData.fields.filter(
        (obj) => obj.documentStatus == 2 || obj.documentStatus == 4
      ).length;
      return submittedLength == totalLength;
    },
    acceptedDocsByType(type) {
      return this.documentData.fields
        .filter((obj) => obj.localDocStatus === type)
        .map((obj) => obj.label);
    },
    changeDocStatus(status) {
      this.LoaderStatus = true;
      this.documentData.fields.map((obj) => {
        if (obj.key == this.selectedDoc.key) {
          obj.localDocStatus = status ? 1 : 0;
        }
      });
      setTimeout(() => {
        this.LoaderStatus = false;
      }, 1500);
      this.$forceUpdate();
    },
    getSelectedLink() {
      if (this.multipleDocs(this.selectedDoc)) {
        return this.selectedDoc.multiFields[
          this.selectedDoc.selectedIndex.split("-")[0]
        ].link;
      } else {
        return this.selectedDoc.uploadedFileLinks[0];
      }
    },
    // getSelectedLabel() {
    //   if (this.multipleDocs(this.selectedDoc)) {
    //     return this.selectedDoc.multiFields[
    //       this.selectedDoc.selectedIndex.split("-")[0]
    //     ].label;
    //   } else return this.selectedDoc.label;
    // },
    selectMultiDoc(doc, index) {
      this.activeCardKey = doc.key;
      this.selectedDoc = { ...doc };
      this.selectedDoc.selectedIndex = `${index}-${doc.multiFields[index].label}`;
      this.$forceUpdate();
    },
    getMultiFieldData(doc) {
      let totalArr = [];
      for (let [index, i] of doc.uploadedFiles.entries()) {
        let eachVal = {
          label: decodeURIComponent(i.split("/").pop().split(".")[0]),
          link: doc.uploadedFileLinks[index],
        };
        totalArr.push(eachVal);
      }
      return totalArr;
    },
    downloadLink(link) {
      const a = document.createElement("a");
      a.href = link;
      a.click();
    },
    getFileType(fileUrl) {
      return getFileType(fileUrl);
    },
    getDocStatus(doc, status) {
      let statusValue = status;
      if ("localDocStatus" in doc) statusValue = doc.localDocStatus;
      let docValue =
        statusValue == 0
          ? ["Rejected", "red"]
          : statusValue == 1
          ? ["Accepted", "green"]
          : statusValue == 3
          ? ["Requested", "grey"]
          : !this.roles.includes("REVIEW_ONBOARDING_DOCS")
          ? ["Uploaded", "yellow"]
          : ["Review", "yellow"];
      return docValue;
    },
    async getKanbanDocs() {
      this.LoaderStatus = true;
      try {
        let payload = {
          candidateID: this.$route.params.candidateID,
          jobID: this.$route.params.jobID,
        };
        const res = await getKanbanDocs(payload);
        if (res.status == 200) {
          this.documentData = res.data.data;
          this.documentData.fields = this.documentData.fields.map((obj) => {
            delete obj.selectedIndex;
            return obj;
          });
          this.checkAndSelect();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async checkAndSelect() {
      this.documentData.fields.map(async (obj) => {
        if (obj.documentStatus != 3 && this.multipleDocs(obj)) {
          obj.show = false;
          obj.multiFields = this.getMultiFieldData(obj);
          obj.multiFields = await Promise.all(
            obj.multiFields.map(async (value) => {
              if (await this.checkIfPasswordProtected(value.link)) {
                value.protected = true;
              }
              return value;
            })
          );
        }
        if (obj.documentStatus == 2 || obj.documentStatus == 4) {
          obj.localDocStatus = obj.documentStatus;
        }
        return obj;
      });
      this.documentData.fields = await Promise.all(
        this.documentData.fields.map(async (obj) => {
          if (obj.documentStatus != 3) {
            if (
              !this.multipleDocs(obj) &&
              (await this.checkIfPasswordProtected(obj.uploadedFileLinks[0]))
            ) {
              obj.protected = true;
            }
          }
          return obj;
        })
      );
      let doc = this.getFilteredDocs[0].find((obj) => obj.documentStatus != 3);
      if (doc) {
        this.selectedDoc = doc;
        if (this.multipleDocs(doc)) {
          this.selectedDoc.selectedIndex = `0-${doc.multiFields[0].label}`;
          this.toggleCollapse(this.selectedDoc.key);
        }
      } else if (this.getFilteredDocs[1].length != 0) {
        this.selectedDoc = this.getFilteredDocs[1][0];
        if (this.multipleDocs(this.selectedDoc)) {
          this.selectedDoc.selectedIndex = `0-${this.selectedDoc.multiFields[0].label}`;
          this.toggleCollapse(this.selectedDoc.key);
        }
      }
      if (this.selectedDoc) this.activeCardKey = this.selectedDoc.key;
      this.$forceUpdate();
      this.LoaderStatus = false;
      // this.selectedDoc = this.documentData.fields[2]
    },
    checkProtected(obj) {
      if (this.multipleDocs(obj)) {
        return (
          obj.multiFields[obj.selectedIndex.split("-")[0]].protected == true
        );
      } else return obj.protected == true;
    },
    goBack() {
      let routename = this.$route.query.jobID ? "Kanban" : "TalentPool";
      this.$router.push({
        name: routename,
        query: this.$route.query,
      });
    },
  },
};
</script>
<style>
.open-toggle-card {
  box-shadow: 0px 1px 8px 0px #0000002b;
}
.ondoc-white-cont {
  background: #f6f9fb;
  box-shadow: 0px 0px 18px 0px #00000029;
  border-radius: 8px;
  margin-top: 12px;
  overflow: hidden;
}
.ondoc-body {
  height: calc(100vh - 225px);
  padding: 15px 40px;
}
.ondoc-footer {
  height: 62px;
  border-top: 1px solid #d7d7d7;
  background-color: #ffffff;
}
.ondoc-left {
  width: 45%;
  height: 100%;
}
.ondoc-left-inner {
  height: 93%;
  width: 100%;
  overflow: auto;
  padding-inline: 5px;
  padding-bottom: 10px;
}
.ondoc-left h4 {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}
.ondoc-left .doc-card {
  background: #ffffff;
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  padding: 10px 12px;
}
.ondoc-left .doc-blue.not-collapsed {
  border: 3px solid #ffffff;
}
.ondoc-left .doc-blue {
  background: #a0c5e880;
  box-shadow: none;
}
.ondoc-black-txt {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #000022;
}
.ondoc-left .list-text h5 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 0;
  border-radius: 6px;
  padding: 2px 28px;
}
.ondoc-left .list-text h5.doc-selected {
  background-color: #e1eef7;
  padding: 7px 28px;
}
.ondoc-tag {
  width: 94px;
  border-radius: 25px !important;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
}
.ondoc-tag.red {
  background-color: #faccd0;
  border: 1px solid #faccd0;
  color: #b00101;
}
.ondoc-tag.green {
  background-color: #038e0033;
  border: 1px solid #038e0033;
  color: #038e00;
}
.ondoc-tag.yellow {
  border: 1px solid #d99100;
  color: #d99100;
}
.ondoc-tag.grey {
  border: 1px solid #8c8c8c;
  color: #8c8c8c;
}
.ondoc-tag.redline {
  border: 1px solid #eb0002;
  color: #eb0002;
}
.ondoc-tag.bluebtn {
  background-color: #20639b;
  border: 1px solid #20639b;
  color: #ffffff;
}
.doc-open-card {
  border-radius: 8px;
  background-color: #ffffff;
}

.doc-card.no-shadow {
  box-shadow: none;
}
.ondoc-right {
  background-color: #ffffff;
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  width: 54%;
  height: 100%;
  overflow: hidden;
}
.ondoc-header {
  background-color: #e1eef7;
  padding: 10px 12px;
}
.ondoc-header span {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #20639b;
}
.ondoc-overflow {
  width: 100%;
  height: calc(100vh - 370px);
  overflow: auto;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding-block: 5px;
}
.ondoc-document {
  width: 475px;
  height: 673px;
  box-shadow: 0px 3.46px 13.58px 0px #00000040;
}
.nodoc-txt {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
}
</style>
